export default __webpack_public_path__ + "static/resume-0d90daf8e1ef33d82c6019d87e9b815e.pdf";